<template>
  <vs-popup
    class="sign-off-taste-panel-popup"
    title="Last Result"
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <vx-card no-shadow class="mb-4">
      <div>
        <h5 class="mb-4 font-semibold">
          {{ batchTitle }}
        </h5>

        <div class="mb-5">
          <small class="label">
            {{ batchLabel }}
          </small>

          <v-select
            v-model="selected_batch"
            :options="lastBatchTestList"
            :label="selectLabel"
            :clearable="false"
            :closeOnSelect="true"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            @input="onSelectBatch"
          />
        </div>

        <div
          v-if="
            selected_batch &&
            selected_batch.latest_quality_control_batch_sign_off
          "
        >
          <div class="grid grid-cols-2 gap-x-8 gap-y-4 text-sm">
            <div>
              <div class="text-gray-500 mb-1">
                {{ batchCodeLabel }}
              </div>
              <div class="font-medium">
                {{ batchCode || "-" }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Taste Panel</div>
              <div class="font-medium">
                <HyperLink
                  :id="
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .id
                  "
                  type="tasting-group"
                >
                  {{
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .code
                  }}
                </HyperLink>
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Signed At</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off
                    .signed_at || "-"
                }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Status</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.status ||
                  "-"
                }}
              </div>
            </div>

            <div class="col-span-2">
              <div class="text-gray-500 mb-1">Signed By</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.signed_by
                    .name || "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div v-else class="py-6 text-center text-sm text-gray-500">
          No previous test result selected.
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button color="success" @click="submit()">
          Save Changes
        </vs-button>
      </div>
    </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import vSelect from "vue-select";
import moment from "moment/moment";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const ManufacturingRepository = RepositoryFactory.get("manufacturing");

export default {
  data() {
    return {
      open: false,
      form: {
        comment: "",
        status: "",
      },
      tastingGroupResult: {},
      signOffStatuses: [],
      batchId: null,
      batchType: "",
      updateMode: false,
      lastBatchTestList: [],
      selected_batch: null,
      rmWoId: null,
      type: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    isRawMaterial() {
      return this.type === "raw-material";
    },

    batchTitle() {
      return this.isRawMaterial
        ? "Result for Last Tested Batch"
        : "Result for Last Tested Work Order";
    },

    batchLabel() {
      return this.isRawMaterial ? "RM Batch" : "Work Order";
    },

    batchCodeLabel() {
      return this.isRawMaterial ? "Batch Code" : "Work Order Code";
    },

    selectLabel() {
      return this.isRawMaterial ? "code" : "work_order_code";
    },

    batchCode() {
      if (!this.selected_batch) return "-";

      return this.isRawMaterial
        ? this.selected_batch.code
        : this.selected_batch.work_order_code;
    },
  },
  methods: {
    async openPopup(item, type) {
      this.type = type;
      this.item = item;
      this.rmWoId = this.getWoRmCode(item);
      await this.getLastTestForBatch();
      this.open = true;
    },

    async getLastTestForBatch() {
      try {
        this.$vs.loading();

        const response = this.isRawMaterial
          ? await ManufacturingRepository.getRawMaterialStockForTastePanel(
              `filter[raw-material-code]=${this.rmWoId}&sort=-signed-at`
            )
          : await ManufacturingRepository.getWoForTastePanel(
              `filter[formulation-code]=${this.rmWoId}&sort=-signed-at`
            );

        const batches = response.data.data;

        const labStandard = {
          code: "Lab Standard",
          work_order_code: "Lab Standard",
          is_lab_standard: true,
        };

        this.lastBatchTestList = [...batches, labStandard];

        if (!batches.length) {
          this.selected_batch = labStandard;
          return;
        }

        const latestBatch = batches[0];

        const signedAt =
          latestBatch.latest_quality_control_batch_sign_off.signed_at;

        if (!signedAt) {
          this.selected_batch = labStandard;
          return;
        }

        const lastTestDate = moment(signedAt, "DD/MM/YYYY HH:mm:ss");

        const monthsSinceLastTest = moment().diff(lastTestDate, "months");

        this.selected_batch =
          monthsSinceLastTest > 12 ? labStandard : latestBatch;
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },

    submit() {
      this.onSelectBatch()
      this.closePopup()
    },

    onSelectBatch() {
      this.$emit(
        "onSelectBatch",
        this.selected_batch.is_lab_standard ? this.selected_batch.code : this.selected_batch.id,
        this.type,
        this.item
      );
    },

    getWoRmCode(item) {
      if (this.type === "raw-material") {
        return `${item.raw_material.category.prefix}-${item.raw_material.company_product_code}`;
      }
      if (this.type === "work-order") {
        return item.formulation.formulation_code;
      }
    },
    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };
      return typeMap[typeString];
    },
    closePopup() {
      this.open = false;
    },
  },
};
</script>
<style scoped>
.sign-off-taste-panel-popup >>> .vs-popup {
  min-width: 50% !important;
  z-index: 99999 !important;
}

.sign-off-taste-panel-popup >>> .vs-popup--background {
  z-index: 99998 !important;
}
</style>
